import { render } from "./PanelHeaderTitle.vue?vue&type=template&id=85fa804a&scoped=true"
import script from "./PanelHeaderTitle.vue?vue&type=script&lang=js"
export * from "./PanelHeaderTitle.vue?vue&type=script&lang=js"

import "./PanelHeaderTitle.vue?vue&type=style&index=0&id=85fa804a&scoped=true&lang=css"
import "./PanelHeaderTitle.vue?vue&type=style&index=1&id=85fa804a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85fa804a"]])

export default __exports__